(() => {
  function initializeScrollZoom(section) {
    if (!section || section.dataset.scrollZoomReady === "true") return;

    if (!window.gsap) {
      setTimeout(() => initializeScrollZoom(section), 150);
      return;
    }

    const image = section.querySelector(".scroll-zoom__image");
    const background = section.querySelector(".scroll-zoom__background");
    const header = document.querySelector("#header-component");

    if (!image || !background) return;

    section.dataset.scrollZoomReady = "true";

    gsap.set([image, background], {
      transformOrigin: "center center"
    });

    function updateAnimation() {
      const position = section.getBoundingClientRect();
      const scrollDistance = section.offsetHeight - window.innerHeight;

      const progress = scrollDistance > 0
        ? Math.max(0, Math.min(1, -position.top / scrollDistance))
        : 0;

      const headerHeight = header?.getBoundingClientRect().height || 0;

      const isScrollZoomActive =
        position.top <= headerHeight &&
        position.bottom >= headerHeight;

      header?.classList.toggle(
        "scroll-zoom-header-hidden",
        isScrollZoomActive
      );

      /* Foreground grows from 1x to 7x */
      gsap.set(image, {
        scale: 1 + progress * 6
      });

      /* Background grows subtly from 1x to 1.1x */
      gsap.set(background, {
        scale: 1 + progress * 0.1
      });

      requestAnimationFrame(updateAnimation);
    }

    updateAnimation();
  }

  function initializeAllScrollZooms() {
    document.querySelectorAll(".scroll-zoom").forEach(initializeScrollZoom);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAllScrollZooms);
  } else {
    initializeAllScrollZooms();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeScrollZoom(event.target);
  });
})();